import React from "react";
import _getConditions from "./condition-builder.js";
import { Translate } from "orion-components/i18n";

const accessControlBuilder = (rule, collections, shapes) => {
	return (
		<div id="rule-statement" className="cb-font-b9">
			{_getMain(rule)}
			{_getConditions(rule, collections, shapes)}
		</div>
	);
};

const _getMain = rule => {
	const alarmType = _getAlarmType(rule);
	const devicesString = _getDevicesString(rule);

	return (
		<Translate value="global.ruleBuilder.accessControl.alarmMe" count={alarmType} primaryValue={devicesString} />
	);
};

const _getAlarmType = rule => {
	const VOWELS = ["a", "e", "i", "o", "u"];

	if (rule.trigger) {
		// Convert alarm type to readable format
		const alarmType = rule.trigger
			.replace(/([A-Z])/g, " $1")
			.replace(/_/g, " ")
			.replace(/^\w/, c => c.toUpperCase())
			.trim();

		// Add "a" or "an" article based on first letter
		const article = VOWELS.includes(alarmType.charAt(0).toLowerCase()) ? "an" : "a";
		return `${article} ${alarmType}`;
	}

	const defaultAlarm = "";
	const article = VOWELS.includes(defaultAlarm.charAt(0).toLowerCase()) ? "an" : "a";
	return `${article} ${defaultAlarm}`;
};

const _getDevicesString = rule => {
	if (!rule.targets || rule.targets.length === 0) {
		return "";
	}

	let devicesString = "";

	rule.targets.forEach((device, index) => {
		const deviceName = device.entityData?.properties?.name || device.name || `Device ${device.id}`;

		if (index === 0) {
			devicesString += deviceName;
		} else if (index === rule.targets.length - 1) {
			devicesString += `, or ${deviceName}`;
		} else {
			devicesString += `, ${deviceName}`;
		}
	});

	return `${devicesString}`;
};

export default accessControlBuilder;
